import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConstants } from '../../app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadShortageFileService {

  constructor(private http: HttpClient) { }

  getShortageRecords(email: string): Observable<any> {
    let params = new HttpParams().set('user_email', email);
    return this.http.get(AppConstants.API_ENDPOINT + AppConstants.API.UPLOAD_SHORTAGE_FILE.GET_RECORDS, { params });
  }

  uploadShortageFile(file: File, date: string, email: string): Observable<any> {
    const formData = new FormData();
    formData.append('shortage_file', file);
    formData.append('upload_date', date);
    formData.append('user_email', email);

    return this.http.post(AppConstants.API_ENDPOINT + AppConstants.API.UPLOAD_SHORTAGE_FILE.UPLOAD_FILE, formData);
  }

  processNdaMapping(fileId: string, batchSize: number, email: string): Observable<any> {
    const formData = new FormData();
    formData.append('file_id', fileId);
    formData.append('batch_size', batchSize.toString());
    formData.append('user_email', email);

    return this.http.post(AppConstants.API_ENDPOINT + AppConstants.API.UPLOAD_SHORTAGE_FILE.PROCESS_NDA_MAPPING, formData);
  }
}
